// extracted by mini-css-extract-plugin
module.exports = {"userProfileWrapper":"user-profile_userProfileWrapper__8T7qt","profileLink":"user-profile_profileLink__mz7dw","profileLinkText":"user-profile_profileLinkText__NkOq8"};